/**
 * Ashren wordmark — inline SVG recreation of the supplied charcoal/mint rule logo.
 * Renders crisp at any size. Variants:
 *  - "dark"  → dark charcoal text on light bg (default, for navbar & light surfaces)
 *  - "light" → white text on dark bg (for footer / dark sections)
 */
export default function AshrenLogo({ variant = "dark", className = "", testId = "ashren-logo" }) {
  const primary = variant === "light" ? "#FFFFFF" : "#1F2430";
  const secondary = variant === "light" ? "rgba(255,255,255,0.75)" : "#8A8F98";
  const rule = "#2ECC9B"; // mint

  return (
    <svg
      viewBox="0 0 260 100"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Ashren Consulting Ltd."
      className={className}
      data-testid={testId}
    >
      <title>Ashren Consulting Ltd.</title>
      <text
        x="130"
        y="52"
        textAnchor="middle"
        fontFamily="'DM Sans', system-ui, sans-serif"
        fontWeight="800"
        fontSize="46"
        letterSpacing="-0.5"
        fill={primary}
      >
        ASHREN
      </text>
      <rect x="12" y="62" width="236" height="3" fill={rule} rx="1.5" />
      <text
        x="130"
        y="88"
        textAnchor="middle"
        fontFamily="'DM Sans', system-ui, sans-serif"
        fontWeight="500"
        fontSize="15"
        letterSpacing="6"
        fill={secondary}
      >
        CONSULTING LTD.
      </text>
    </svg>
  );
}
